import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestRevisionGet = {
    path: "/revision/:hash",
    method: RouteHttpVerb.GET
};
export { locationRestRevisionGet };
